import React, {useEffect, useState, createElement} from "react"
import view from "./blog.module.scss";
import { Link } from "gatsby"
import {FacebookShareButton, TwitterShareButton, FacebookIcon, XIcon} from "react-share";

const Blog = (props) => {
  const {data, title} = props;
  const location = typeof window !== 'undefined' && window.location
  const shareLink = typeof window !== 'undefined' && window.location ? location.href : '';
  const blogCount = data.blogposts.length ;
  // console.log(data.blogposts);
  useEffect(()=> {

    let blogPTags = document.getElementsByTagName("p");
    for(let i = 0; i < blogPTags.length; i++){
      if(blogPTags[i].innerHTML === "" || blogPTags[i].innerHTML === null){
        blogPTags[i].setAttribute("class","rich-text-inline");
      }
    }
    var paraClasses = document.querySelectorAll(".rich-text-inline");
    for (let i = 0; i < paraClasses.length; i++) {
      paraClasses[i].style.height = "25px";
    }
  })

  function handleThumbnailAltText() {
    if (!data.thumbnailAltText || data.thumbnailAltText === "") {
      return `${title} Blog Image`;
    } else {
      return data.thumbnailAltText;
    }
  }

  // format publication date to display Month, Day, Year
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    if (isNaN(date.getTime())) {
        // Invalid date format, return input as is
        return inputDate;
    }

    const options = { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
    };

    return date.toLocaleDateString(undefined, options);
  }

  // check if a date is in the future
  const isFutureDate = (dateString) => {
  const today = new Date();
  const date = new Date(dateString);
  return date > today;
  };
  
  let formattedDate = formatDate(data.publicationDate);
  let isFuture = isFutureDate(data.publicationDate);


  return(
    <>
     
      
      <div className={`${view['blog-main-content']}`}>
        {title? <h1 style={{marginBottom:0}}>{title}</h1> : null }
        {data.publicationDate? <p style={{fontStyle:"italic", marginTop:5}}>{isFuture ? "Scheduled: " : "Published: "} {formattedDate}</p> : null}
        
        <div className={`${view['blog-underline']}`}></div>

        {/**SHARE GOES HERE */}
        <FacebookShareButton style={{marginRight:8}} url={`${shareLink}`}>
          <FacebookIcon 
            size={32}
            round
            bgStyle={{fill: 'black'}}
            />
        </FacebookShareButton>
        <TwitterShareButton  url={`${shareLink}`}>
          <XIcon 
            size={32}
            round
            />
        </TwitterShareButton>
        {data.thumbnailImage?
          <div style={{width:'100%', maxWidth:750, margin:'0 auto'}}>
            <img className={`${view['blog-main-thumbnail']}`} src={data.thumbnailImage} alt={handleThumbnailAltText()}/>
          </div>
          : 
          null
        }
        <div className={`${view['rich-para-cont']}`} style={{fontSize: 15, lineHeight:1.8}} dangerouslySetInnerHTML={{ __html: data.blogContent}}></div>
        <div className={`${view['tags']}`}>
        <p>
         {blogCount > 0?<>Posted in:&nbsp;</>:<></>}
          {data.blogposts.map((tags, index)=>{
            const tagNameLower = tags?.tag?.toLowerCase();
            if(tags?.tag == 'undefinded'){
              return(
                <></>
              ) }
  
            return(
              <>
              {blogCount > 1 ?
                <>
                  {index === blogCount - 1? <span>and&nbsp;</span> : <></>}
                    <Link href={`/categories/${tagNameLower}`}>{tags.tag}</Link>
                  {index === blogCount - 1?<></>:<span>,&nbsp;</span>}  
                </>
                :
                <>
                  <Link href={`/categories/${tagNameLower}`}>{tags?.tag}</Link>&nbsp;
                </>
              }
              </>
            )
          })}
        </p>
      </div>
      </div>
     
    </>
  )
}

export default Blog;
